import { atom } from "jotai"
import { boxTypes } from "../utils/data"

export const userAtom = atom()
export const cartListAtom = atom([])
export const priceRangeAtom = atom({ min: 0, max: 500000 })
export const yearRangeAtom = atom({ min: 1900, max: new Date().getFullYear() })
export const showMessageBoxAtom = atom(false)
export const showNotificationsBoxAtom = atom(false)
export const showCartAtom = atom(false)
export const showIndividualMessageBoxAtom = atom(false)
export const recipientIdAtom = atom(null)
export const showAddPaymentMethodAtom = atom(false)
export const searchParamsAtom = atom({ categories: [], rarities: [], conditions: [], boxTypes: [] })
export const purchasedUserCounterAtom = atom(0)
export const membershipsAtom = atom({})